import { render, staticRenderFns } from "./ClinicEdit.vue?vue&type=template&id=51c52c69&scoped=true"
import script from "./ClinicEdit.vue?vue&type=script&lang=js"
export * from "./ClinicEdit.vue?vue&type=script&lang=js"
import style0 from "./ClinicEdit.vue?vue&type=style&index=0&id=51c52c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c52c69",
  null
  
)

export default component.exports